/* eslint-disable max-lines */
import React, { useEffect } from 'react';
import { StepWizardChildProps } from 'react-step-wizard';

import { Group, Definition, WfInfoResponse, Task } from 'models/response';

import utils from 'utils';

import { StepContainer, StyledRowWrapper, Top, StyledLine, StyledText } from './styles';

import Header from 'components/Modal/Header';
import CommonButton from 'components/Buttons/CommonButton';
import Dropdown from 'components/Input/dropdown/Dropdown';
import TextInput from 'components/Input/TextInput';

import Hierarchy from 'components/Hierarchy';

export interface Props extends StepWizardChildProps {
  infoForSuspend: WfInfoResponse;
  dropOptOne: { value: string; label: string }[];
  selectedReason: { value: string; label: string };
  selectedDescription: { value: number; label: string } | null;
  infoInput: string;
  definitions: Definition[] | null;
  setSelectedDefinition: (definition: Definition) => void;
  setSelectedTask: (isActive?: boolean, task?: Task) => void;
  setSelectedGroups: (groups: Group[]) => void;
  preSelectedDefinition: Definition | null;
  preSelectedTask: Task | null;
  preSelectedGroups: Group[] | null;
}

const CausalChoice: React.FC<Partial<Props>> = (props) => {
  const {
    goToStep,
    infoForSuspend,
    dropOptOne,
    selectedReason,
    selectedDescription,
    infoInput,
    definitions,
    setSelectedTask,
    setSelectedGroups,
    setSelectedDefinition,
    preSelectedDefinition,
    preSelectedTask,
    preSelectedGroups,
  } = props;
  const t = utils.intl.useTranslator();

  useEffect(() => {
    preSelectedGroups && goToStep && goToStep(4);
  }, [preSelectedGroups, goToStep]);

  const columns: { accessor: string; Header: string }[] = [
    { accessor: 'username', Header: 'User' },
    { accessor: 'name', Header: 'Name' },
  ];

  const searchTypeValues: { value: string; label: string; parent: 'one' | 'two' | 'three' | 'table' | 'table-two' }[] =
    [
      { value: 'definition', label: 'Definition', parent: 'one' },
      { value: 'task', label: 'Task', parent: 'two' },
      { value: 'group', label: 'Group', parent: 'three' },
      { value: 'user', label: 'User', parent: 'table' },
      { value: 'username', label: 'User Name', parent: 'table-two' },
    ];

  return (
    <StepContainer>
      <Header title={t('send-to-workflow')} />
      {dropOptOne ? (
        <Top>
          <CommonButton
            id="back-btn"
            noPadding
            value={t('back')}
            scope="tertiary"
            action={() => (goToStep ? goToStep(1) : {})}
          />
          <StyledRowWrapper>
            <Dropdown id="reason-dropdown" value={selectedReason} disabled options={dropOptOne} />
            {selectedReason?.value === 'causale' ? (
              infoForSuspend ? (
                <Dropdown
                  id="description-dropdown"
                  options={utils.input.buildOptions(infoForSuspend.causals || [], 'causalName', 'idWfCausal')}
                  value={selectedDescription}
                  disabled
                />
              ) : null
            ) : (
              <TextInput id="causal-choice-info" disabled value={infoInput} />
            )}
          </StyledRowWrapper>
        </Top>
      ) : null}
      <StyledLine />
      <StyledText>{t('causal-selected')}</StyledText>
      {definitions && (
        <Hierarchy
          title="definition-wf-selected"
          hasSearch
          searchTypeValues={searchTypeValues}
          parentsOne={definitions}
          parentOneName="wfName"
          parentOneId="idDefinition"
          parentOneSelection={(value: any) => {
            setSelectedTask && setSelectedTask();
            setSelectedGroups && setSelectedGroups([]);
            setSelectedDefinition && setSelectedDefinition(value);
          }}
          preSelectedParentOne={preSelectedDefinition}
          parentOneChild="tasks"
          parentTwoName="taskName"
          parentTwoId="idTask"
          parentTwoSelection={(isActive?: boolean, value?: any) => {
            setSelectedTask && setSelectedTask(isActive, value);
            setSelectedGroups && setSelectedGroups([]);
          }}
          preSelectedParentTwo={preSelectedTask}
          parentTwoChild="groups"
          parentThreeName="groupName"
          parentThreeId="idGroup"
          parentThreeSelection={(value?: any) => {
            setSelectedGroups && setSelectedGroups(value);
          }}
          preSelectedParentThree={preSelectedGroups}
          parentThreeChild="users"
          parentThreeMulti={true}
          idRowTable="idUser"
          columns={columns}
          tableValueName="username"
          tableValueNameTwo="name"
          toCleanSelections={selectedDescription}
        />
      )}
    </StepContainer>
  );
};

export default CausalChoice;
